import * as React from "react"

const ZoomInSVG = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={23} height={22} fill="none" {...props}>
		<path
			fill="#475163"
			d="M9.85 6.37a.687.687 0 0 1 .688.688v1.605h1.604a.688.688 0 1 1 0 1.374h-1.604v1.605a.688.688 0 0 1-1.375 0v-1.604H7.559a.687.687 0 1 1 0-1.375h1.604V7.058a.688.688 0 0 1 .687-.687Z"
		/>
		<path
			fill="#475163"
			fillRule="evenodd"
			d="M5.449 13.7a6.188 6.188 0 0 0 8.237.458l4.726 4.726a.688.688 0 1 0 .972-.971l-4.725-4.727a6.188 6.188 0 1 0-9.21.514Zm.972-7.78a4.813 4.813 0 1 0 6.801 6.812l.005-.005.004-.005a4.812 4.812 0 1 0-6.81-6.801Z"
			clipRule="evenodd"
		/>
	</svg>
)

export default ZoomInSVG
